import { Container, Row, Col } from "react-bootstrap";
import { Building2, Award, TrendingUp, MapPin, CheckCircle, Globe, ShieldCheck } from 'lucide-react';
import img1 from '../../assets/img/about/portada.jpg';
import img2 from '../../assets/img/logo25.png';

function Nosotros() {
    const caracteristicas = [
        {
            icon: <Award size={24} />,
            title: "+25 Años",
            description: "De experiencia en el mercado"
        },
        {
            icon: <ShieldCheck size={24} />,
            title: "Alta Calidad",
            description: "Herramientas profesionales certificadas"
        },
        {
            icon: <Globe size={24} />,
            title: "Cobertura Nacional",
            description: "Distribución en todo Bolivia"
        },
        {
            icon: <TrendingUp size={24} />,
            title: "Innovación",
            description: "Tecnología de vanguardia"
        }
    ];

    // const categorias = [
    //     "Construcción",
    //     "Jardinería",
    //     "Carpintería",
    //     "Cerrajería",
    //     "Chapería",
    //     "Plomería",
    //     "Electricidad",
    //     "Pintura"
    // ];

    const fortalezas = [
        { icon: <CheckCircle size={20} />, text: "Distribuidores exclusivos de TRUPER en Bolivia" },
        { icon: <CheckCircle size={20} />, text: "Productos certificados con garantía internacional" },
        { icon: <CheckCircle size={20} />, text: "Red de distribución a nivel nacional" },
    ];

    return (
        <section className="nosotros-section">
            {/* Fondo decorativo */}
            <div className="nosotros-background">
                <div className="nosotros-shape nosotros-shape-1"></div>
                <div className="nosotros-shape nosotros-shape-2"></div>
                <div className="nosotros-shape nosotros-shape-3"></div>
                <div className="nosotros-dots-pattern"></div>
            </div>

            <Container className="nosotros-container">
                {/* Header */}
                <div className="nosotros-header text-center">
                    <div className="nosotros-badge">
                        <Building2 size={20} />
                        <span>Conócenos</span>
                    </div>
                    <h2 className="nosotros-title">
                        Acerca de <span className="text-highlight-nosotros">Nosotros</span>
                    </h2>
                    <div className="title-divider-nosotros"></div>
                </div>

                {/* Contenido principal */}
                <Row className="align-items-center g-5 nosotros-main-content">
                    {/* Columna de contenido */}
                    <Col lg={5}>
                        <div className="nosotros-content">
                            {/* Intro */}
                            <div className="nosotros-intro">
                                <h3 className="intro-title">
                                    Líderes en Distribución de Herramientas Profesionales
                                </h3>
                                <p className="intro-text">
                                    Somos una empresa dedicada a la <strong>comercialización de materiales</strong> de 
                                    construcción, jardinería, carpintería, cerrajería, chapería y más, con{' '}
                                    <span className="text-highlight-inline">más de 25 años de experiencia</span> en el mercado boliviano.
                                </p>
                            </div>

                            {/* Descripción principal */}
                            <p className="nosotros-description">
                                Somos <strong>pioneros en herramientas de alta calidad</strong>, utilizando tecnología 
                                innovadora para dar continuidad a la oferta de materiales de primera línea.
                            </p>

                            {/* Destacado especial */}
                            <div className="nosotros-destacado">
                                <div className="destacado-icon">
                                    <Award size={32} />
                                </div>
                                <div className="destacado-content">
                                    <h4 className="destacado-title">Distribuidores Exclusivos</h4>
                                    <p className="destacado-text">
                                        Somos la <strong>única empresa autorizada</strong> para la distribución de 
                                        herramientas <span className="brand-truper">TRUPER</span> que opera en{' '}
                                        <strong>todo Bolivia</strong>.
                                    </p>
                                </div>
                            </div>

                            {/* Lista de fortalezas */}
                            
                        </div>
                    </Col>

                    {/* Columna de imagen */}
                    <Col lg={7}>
                        <div className="nosotros-image-section">
                            {/* Imagen principal */}
                            <div className="nosotros-image-wrapper">
                                {/* Decoraciones */}
                                <div className="image-decoration-1"></div>
                                <div className="image-decoration-2"></div>
                                
                                <img 
                                    src={img1} 
                                    alt="Salcedo Importaciones" 
                                    className="nosotros-image"
                                />

                                {/* Badge flotante de experiencia */}
                                <div className="floating-experience-badge">
                                    <div className="badge-content">
                                        <img 
                                            src={img2} 
                                            alt="Salcedo Importaciones" 
                                            className="nosotros-image2"
                                        />
                                        
                                    </div>
                                </div>

                                {/* Stats flotantes */}
                                <div className="floating-stats">
                                    {/* <div className="stat-item">
                                        <Users size={24} />
                                        <span>100+ Colaboradores</span>
                                    </div> */}
                                    <div className="stat-item">
                                        <MapPin size={24} />
                                        <span>Cobertura Nacional</span>
                                    </div>
                                </div>
                            </div>
                            <div className="fortalezas-list py-4">
                                {fortalezas.map((fortaleza, index) => (
                                    <div 
                                        key={index} 
                                        className="fortaleza-item"
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                    >
                                        <div className="fortaleza-icon">
                                            {fortaleza.icon}
                                        </div>
                                        <span>{fortaleza.text}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Sección de Características */}
                <div className="caracteristicas-section">
                    <Row className="g-4">   
                        {caracteristicas.map((caracteristica, index) => (
                            <Col xs={6} md={3} key={index}>
                                <div 
                                    className="caracteristica-card"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <div className="caracteristica-icon">
                                        {caracteristica.icon}
                                    </div>
                                    <h4 className="caracteristica-title">{caracteristica.title}</h4>
                                    <p className="caracteristica-description">{caracteristica.description}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Sección de Categorías */}
                {/* <div className="categorias-section">
                    <h3 className="categorias-title">
                        Categorías de Productos
                    </h3>
                    <div className="categorias-grid">
                        {categorias.map((categoria, index) => (
                            <div 
                                key={index} 
                                className="categoria-tag"
                                style={{ animationDelay: `${index * 0.05}s` }}
                            >
                                <CheckCircle size={18} />
                                <span>{categoria}</span>
                            </div>
                        ))}
                    </div>
                </div> */}

                {/* CTA Final */}
                {/* <div className="nosotros-cta">
                    <div className="cta-content-nosotros">
                        <h3 className="cta-title-nosotros">
                            ¿Listo para Trabajar con los Mejores?
                        </h3>
                        <p className="cta-description-nosotros">
                            Descubre nuestra amplia gama de productos y servicios profesionales
                        </p>
                        <div className="cta-buttons-nosotros">
                            <a href="/productos" className="btn-nosotros-primary">
                                Ver Productos
                            </a>
                            <a href="/contacto" className="btn-nosotros-secondary">
                                Contáctanos
                            </a>
                        </div>
                    </div>
                </div> */}
            </Container>
        </section>
    );
}

export default Nosotros;